import React from 'react';
import ServicePlan from '../components/ServicePlan';
import { ArrowRight, CheckCircle, Shield, Clock } from 'lucide-react';
const Home = () => {
  return <div className="w-full" data-id="element-461">
      {/* Hero Section */}
      <section className="bg-cover bg-center h-[600px] relative" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/67we8XB4R1dV4tWeQd3Sro/03._Hero.png')"
    }} data-id="element-462">
        <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-463"></div>
        <div className="container mx-auto px-4 h-full flex items-center relative z-10" data-id="element-464">
          <div className="max-w-2xl text-white" data-id="element-465">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-466">
              Fast, Reliable Appliance Repairs Across the UK
            </h1>
            <p className="text-xl mb-8" data-id="element-467">
              Professional service when you need it most
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-468">
              <a href="#services" className="bg-[#f05a28] text-white px-6 py-3 rounded-md font-semibold flex items-center hover:bg-[#d94e20] transition" data-id="element-469">
                Our Services <ArrowRight size={18} className="ml-2" data-id="element-470" />
              </a>
              <a href="/contact" className="bg-transparent border-2 border-white text-white px-6 py-3 rounded-md font-semibold hover:bg-white hover:text-[#869CE4] transition" data-id="element-471">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Intro Section */}
      <section className="py-16 bg-gray-50" data-id="element-472">
        <div className="container mx-auto px-4" data-id="element-473">
          <div className="max-w-3xl mx-auto text-center" data-id="element-474">
            <h2 className="text-3xl font-bold text-[#869CE4] mb-6" data-id="element-475">
              Welcome to Peakwave
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-476">
              At Peakwave, we specialise in providing fast, reliable appliance
              repairs and comprehensive service plans across the UK. Our team of
              highly-trained engineers delivers professional service with
              fixed-price plans, ensuring complete peace of mind for your home
              appliances. With UK-based support and years of industry
              experience, we're here to keep your appliances running smoothly.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12" data-id="element-477">
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-478">
                <div className="w-16 h-16 bg-[#eef1fb] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-479">
                  <Shield className="text-[#869CE4]" size={28} data-id="element-480" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-[#869CE4]" data-id="element-481">
                  Reliable Protection
                </h3>
                <p className="text-gray-600" data-id="element-482">
                  Comprehensive coverage for your essential home appliances with
                  fixed-price plans.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-483">
                <div className="w-16 h-16 bg-[#eef1fb] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-484">
                  <div className="text-[#869CE4]" size={28} data-id="element-485" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-[#869CE4]" data-id="element-486">
                  Expert Engineers
                </h3>
                <p className="text-gray-600" data-id="element-487">
                  Our qualified technicians are trained to repair all major
                  appliance brands and models.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-488">
                <div className="w-16 h-16 bg-[#eef1fb] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-489">
                  <Clock className="text-[#869CE4]" size={28} data-id="element-490" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-[#869CE4]" data-id="element-491">
                  Quick Response
                </h3>
                <p className="text-gray-600" data-id="element-492">
                  Fast service with appointments typically available within
                  24-48 hours.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Services Section */}
      <section id="services" className="py-16" data-id="element-493">
        <div className="container mx-auto px-4" data-id="element-494">
          <div className="text-center mb-12" data-id="element-495">
            <h2 className="text-3xl font-bold text-[#869CE4] mb-4" data-id="element-496">
              Our Service Plans
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-497">
              Choose the perfect service plan to protect your home appliances
              and enjoy complete peace of mind with our professional care and
              support.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-498">
            <ServicePlan title="One-Year Service Plan (1 Appliance)" price="£99.00" description="Enjoy complete peace of mind with 12 months' professional care. Includes unlimited repairs and priority support, ensuring your appliance is always in safe hands." imageUrl="https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" stripeLink="https://buy.stripe.com/28E5kx1Bhcj52icfQT1gs00" data-id="element-499" />
            <ServicePlan title="One-Year Service Plan (TV + Set-Top Box)" price="£120.00" description="Protect your TV and set-top box with our dedicated technicians. Enjoy uninterrupted entertainment with unlimited repairs and rapid-response service for 12 months." imageUrl="https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" stripeLink="https://buy.stripe.com/28E5kx1Bhcj52icfQT1gs00" data-id="element-500" />
          </div>
        </div>
      </section>
      {/* Why Choose Us Section */}
      <section className="py-16 bg-[#869CE4] text-white" data-id="element-501">
        <div className="container mx-auto px-4" data-id="element-502">
          <div className="text-center mb-12" data-id="element-503">
            <h2 className="text-3xl font-bold mb-4" data-id="element-504">Why Choose Peakwave?</h2>
            <p className="text-lg max-w-3xl mx-auto" data-id="element-505">
              We're committed to providing exceptional service and value to our
              customers across the UK.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-506">
            <div className="flex items-start" data-id="element-507">
              <CheckCircle className="text-[#f05a28] mr-4 mt-1 flex-shrink-0" size={24} data-id="element-508" />
              <div data-id="element-509">
                <h3 className="text-xl font-semibold mb-2" data-id="element-510">UK-Wide Coverage</h3>
                <p data-id="element-511">
                  Our services are available across mainland UK, with quick
                  response times and local engineers.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-512">
              <CheckCircle className="text-[#f05a28] mr-4 mt-1 flex-shrink-0" size={24} data-id="element-513" />
              <div data-id="element-514">
                <h3 className="text-xl font-semibold mb-2" data-id="element-515">
                  Fixed Price Plans
                </h3>
                <p data-id="element-516">
                  No hidden costs or surprise fees. Our service plans offer
                  complete transparency and value.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-517">
              <CheckCircle className="text-[#f05a28] mr-4 mt-1 flex-shrink-0" size={24} data-id="element-518" />
              <div data-id="element-519">
                <h3 className="text-xl font-semibold mb-2" data-id="element-520">
                  Qualified Engineers
                </h3>
                <p data-id="element-521">
                  All our technicians are fully qualified, experienced, and
                  regularly trained on the latest appliance models.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-522">
              <CheckCircle className="text-[#f05a28] mr-4 mt-1 flex-shrink-0" size={24} data-id="element-523" />
              <div data-id="element-524">
                <h3 className="text-xl font-semibold mb-2" data-id="element-525">
                  Customer Satisfaction
                </h3>
                <p data-id="element-526">
                  We pride ourselves on delivering exceptional service and
                  maintaining high customer satisfaction.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-gray-50" data-id="element-527">
        <div className="container mx-auto px-4" data-id="element-528">
          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 max-w-4xl mx-auto" data-id="element-529">
            <div className="text-center mb-8" data-id="element-530">
              <h2 className="text-3xl font-bold text-[#869CE4] mb-4" data-id="element-531">
                Ready to Protect Your Appliances?
              </h2>
              <p className="text-lg text-gray-600" data-id="element-532">
                Get started today with our professional service plans and enjoy
                complete peace of mind.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-533">
              <a href="#services" className="bg-[#869CE4] text-white px-8 py-3 rounded-md font-semibold text-center hover:bg-[#6a7fc7] transition" data-id="element-534">
                View Service Plans
              </a>
              <a href="/contact" className="bg-[#f05a28] text-white px-8 py-3 rounded-md font-semibold text-center hover:bg-[#d94e20] transition" data-id="element-535">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Home;